import './Settings.css';

const Settings = ({ closeApp }) => {
    return (
        <div className="settings-app">
            
            <h2>Settings</h2>

            <div style={{ fontSize: '0.8em', margin: '20px' }}>This app doesn't do anything yet. A work in progress..</div>

            <div className="app-open-close-button">
                <button onClick={closeApp} style={{ marginTop: '5px' }}>Close</button>
            </div>

            <br />

            <div className="settings-section">
                <div className="settings-option">
                    <div className="settings-option-icon"></div>
                    Airplane Mode
                </div>
                <div className="settings-option">
                    <div className="settings-option-icon" style={{ backgroundColor: 'royalblue' }}></div>
                    Wi-Fi
                </div>
            </div>

            <br />

            <div className="settings-section">
                <div className="settings-option">
                    <div className="settings-option-icon" style={{ backgroundColor: 'gray' }}></div>
                    General
                </div>
                <div className="settings-option">
                    <div className="settings-option-icon" style={{ backgroundColor: 'lightblue' }}></div>
                    Wallpaper
                </div>
            </div>

            <br />
            
            {/* <input type="text" /><br />
            <br /> */}

        </div>
    );
};
export default Settings;